import { motion, useMotionValueEvent, useScroll } from 'framer-motion';
import { useState } from 'react';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';



export default function ProfileBar({ isOpen, setIsOpen }) {

  const [ num, setNum ] = useState(0);
  const { scrollYProgress } = useScroll()

  const navigate = useNavigate()


  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    //console.log(latest);
    console.log(num)
    setNum(latest)
  })


    return (
        <header className={` w-full h-1/12 top-0 py-6 px-10 overflow-hidden flex justify-between items-center
            md:px-2 xs:px-8
            ${isOpen ? 'z-[60] ' : 'z-20'} `} >
              <section className={` relative    `}>
                <motion.div
                  className="text-4xl font-bold flex items-center text-persian pl-0 "
                  initial={{ y: -100, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.8 }}
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={()=> navigate('/')}
                > 
                 <FaArrowLeftLong />
                </motion.div>
              </section>
              <motion.section
               className="absolute right-6 h-5 py-2 m-2 z-[60]
               "
               initial={{ y: -100, opacity: 0 }}
               animate={{ y: 0, opacity: 1 }}
               transition={{ duration: 0.8 }
               
              }
               >
                    <motion.button
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={() => setIsOpen(!isOpen)}
                        className={`relative text-2xl font-black ${ isOpen ? 'text-beige   ' : 'text-persian '} flex flex-col justify-center items-end space-y-1`}
                    >
                        {/* Primera línea */}
                        <motion.div
                        className={` ${isOpen ? 'w-8 bg-beige ' : 'w-12 bg-persian'} h-1`}
                        animate={{ rotate: isOpen ? 45 : 0, y: isOpen ? 1 : 0 }}
                        transition={{ duration: 0.3 }}
                        />
                        {/* Segunda línea */}
                        <motion.div
                        className={`w-8 h-1 ${isOpen ? 'bg-beige' : 'bg-persian'} `}
                        animate={{ rotate: isOpen ? -45 : 0, y: isOpen ? -8 : 0 }}
                        transition={{ duration: 0.3 }}
                        />
                    </motion.button>
                </motion.section>
          </header>
    )
}